{
  "home-page-title": "Application Web",
  "clear-btn": "Effacer",
  "close-btn": "Fermer",
  "cancel-btn": "Annuler",
  "delete-btn": "Supprimer",
  "share-btn": "Partager",
  "download-btn": "Télécharger",
  "ok-btn": "OK",
  "done-btn": "Terminé",
  "yes-btn": "Oui",
  "no-btn": "Non",
  "create-story-btn": "Créer une story",
  "submit-registration-btn": "CONTINUER",
  "save-btn": "Enregistrer",
  "apply-btn": "Appliquer",
  "checkout-btn": "Paiement",
  "info-title": "Info",
  "registration-page-title": "Inscription",
  "contact-completion-page-title": "Compléter vos coordonnées",
  "registration-name-placeholder": "Votre nom",
  "registration-email-placeholder": "Votre e-mail",
  "registration-email-or-phone-placeholder": "Votre e-mail ou votre numéro de téléphone US",
  "registration-country-code-default": "US +1",
  "registration-accept-label": "J'accepte",
  "registration-privacy-link": "Conditions générales",
  "registration-sms-agreement-label": "J'accepte de recevoir des messages de notification de Storibox au numéro de téléphone fourni ci-dessus. Je comprends que je recevrai des SMS contenant des mises à jour et des liens vers mes images. Des frais de données et de messagerie peuvent s'appliquer. Répondez STOP pour vous désinscrire.",
  "registration-submit-loading-label": "Chargement...",
  "registration-create-attendee-error-message": "Impossible de créer un participant. Veuillez réessayer plus tard.",
  "registration-create-attendee-email-confirmation-error-message": "Impossible de créer un participant. Veuillez réessayer plus tard. Vérifiez que votre adresse e-mail est confirmée.",
  "registration-invalid-us-phone-message": "Veuillez utiliser uniquement un numéro de téléphone US au format suivant : +11234567890.",
  "registration-us-phone-length-message": "Le numéro de téléphone doit comporter 10 chiffres après l'indicatif (+1), mais le vôtre en comporte {{length}}.",
  "registration-contact-required-message": "Une adresse e-mail ou un numéro de téléphone est requis.",
  "registration-invalid-email-message": "Veuillez saisir une adresse e-mail valide.",
  "registration-email-required-message": "L'adresse e-mail est requise.",
  "registration-sms-consent-required-message": "Votre consentement à l'accord SMS est requis. Sans cela, vous ne pouvez pas vous inscrire au service.",
  "registration-privacy-consent-required-message": "Votre consentement aux Conditions générales est requis. Sans cela, vous ne pouvez pas vous inscrire au service.",
  "incognito-page-title": "Mode navigation privée détecté",
  "incognito-main-title": "Vous êtes en mode privé",
  "incognito-message": "Veuillez copier et ouvrir ce lien dans une fenêtre de navigateur standard.",
  "incognito-link-placeholder": "Votre lien",
  "incognito-copy-link-btn": "Copier le lien",
  "incognito-copy-link-title": "Copier le lien dans le presse-papiers",
  "incognito-copy-success-message": "✓ Lien copié dans le presse-papiers !",
  "incognito-copy-manual-message": "Veuillez copier manuellement le lien ci-dessus",
  "incognito-safari-step-one-text": "Appuyez sur le bouton des onglets",
  "incognito-safari-step-two-html": "Appuyez sur <strong>[number]</strong> onglets, puis sur Terminé.",
  "incognito-chrome-step-one-text": "Appuyez sur le bouton des onglets.",
  "incognito-chrome-step-two-html": "Appuyez sur <strong>[number]</strong> onglets.",
  "selfies-empty-title": "Il manque un selfie !",
  "selfies-empty-message": "Veuillez ajouter une belle photo portrait\nde chaque personne de votre groupe afin de retrouver\nvos images rapidement.",
  "selfies-add-btn": "+ Ajouter",
  "purchase-btn": "Acheter",
  "home-select-all-btn": "Tout sélectionner",
  "home-selected-count-label_one": "1 élément sélectionné",
  "home-selected-count-label_other": "{{count}} éléments sélectionnés",
  "home-empty-album-message": "L'album est vide",
  "home-empty-album-subtext-message": "Il n'y a pas encore d'images dans votre<br>album.",
  "home-qr-modal-title": "Code de mon album",
  "home-qr-modal-message": "Scannez ce QR au kiosque pour accéder à vos photos, ou présentez-le à nos photographes itinérants lorsqu'ils le demandent.",
  "home-qr-scanner-message": "Scannez le code QR sur vos photos ou vidéos depuis le kiosque de visualisation afin d'associer vos médias à cette application.",
  "home-qr-camera-access-message": "🎥 Veuillez vous assurer d'avoir autorisé l'accès à la caméra pour scanner le code QR.",
  "home-qr-scanner-show-my-qr-btn": "Afficher mon QR",
  "menu-registered-selfies": "Visages enregistrés",
  "menu-qr-scanner": "Scanner QR",
  "menu-album-code": "Code de mon album",
  "menu-privacy": "Conditions générales",
  "menu-faq": "FAQ",
  "menu-support": "Assistance",
  "home-step-label": "Étape {{amount}} sur {{total}}",
  "home-select-up-to-images-title_one": "Sélectionnez jusqu'à 1 image",
  "home-select-up-to-images-title_other": "Sélectionnez jusqu'à {{count}} images",
  "home-select-as-many-images-title": "Sélectionnez autant d'images que vous le souhaitez",
  "home-select-target-label": "pour \"{{name}}\"",
  "home-no-albums-found-message": "Aucun album trouvé.",
  "home-event-config-missing-message": "Cet événement n'est pas configuré pour l'application web.",
  "home-create-story-waiting-message": "Votre story est en cours de création. Veuillez vérifier à nouveau votre album dans quelques minutes.",
  "home-ugc-tooltip-message": "Vous pouvez télécharger des photos depuis votre galerie et les faire imprimer au kiosque !",
  "home-face-reco-tooltip-message": "Veuillez télécharger un selfie ou un bon portrait de chaque personne de votre groupe afin que nous puissions retrouver vos images !",
  "home-select-to-share-or-download-message": "Sélectionnez au moins une image à partager ou à télécharger.",
  "home-select-without-watermark-message": "Seules les images sans filigrane peuvent être partagées ou téléchargées.",
  "home-select-to-delete-message": "Sélectionnez au moins une image à supprimer.",
  "home-share-download-locked-message": "Certaines des photos que vous avez sélectionnées sont verrouillées. Pour les partager ou les télécharger, veuillez acheter un Pass numérique.",
  "home-face-register-help-message": "Veuillez vous assurer que votre visage est uniformément éclairé et entièrement visible. Gardez une expression neutre.",
  "home-no-selfies-suggestion-message": "Oups, il semble que vous n'ayez pas enregistré votre selfie. Prenez-en un maintenant pour retrouver vos précieux souvenirs.",
  "home-no-face-mask-message": "PAS DE MASQUE",
  "home-selfie-maybe-later-btn": "Peut-être plus tard",
  "home-delete-stock-warning-message": "Vous avez sélectionné une image de stock de l'événement à supprimer. Elle ne peut pas être supprimée de votre album et sera ignorée.",
  "home-delete-confirm-message": "La suppression d'images de votre album est irréversible. Voulez-vous vraiment continuer ?",
  "home-delete-reason-not-wanted": "Je ne veux pas de ces images dans mon album",
  "home-delete-reason-not-mine": "Ces images ne sont pas à moi",
  "home-delete-confirm-btn": "Oui, supprimer",
  "home-upload-unsupported-format-message": "Format d'image non pris en charge. Veuillez utiliser un autre fichier image.",
  "home-upload-generic-error-message": "Une erreur s'est produite lors du téléchargement de votre photo. Veuillez réessayer ou contacter l'assistance.",
  "home-upload-limit-reached-message": "Vous avez atteint votre limite de téléchargements de photos. Veuillez contacter l'assistance si vous devez en ajouter davantage.",
  "home-upload-processing-error-message": "Une erreur s'est produite lors du traitement de votre photo. Veuillez réessayer ou contacter l'assistance.",
  "home-upload-processing-message": "Vos photos apparaîtront dans votre album dans une minute !",
  "home-upload-photo-message": "Téléchargez une photo depuis votre galerie pour l'imprimer !",
  "home-turn-me-into-tag-upload-message": "Prenez un selfie ou téléchargez un portrait depuis votre galerie.",
  "home-turn-me-into-tag-processing-message": "Nous travaillons sur la transformation de votre image ! Actualisez cette page dans une minute environ.",
  "home-download-waiting-message": "Téléchargement des fichiers.<br/>Veuillez patienter.",
  "download-selection-too-large-message": "Désolé, cette sélection est trop volumineuse pour être téléchargée en une seule fois. Veuillez choisir moins de photos ou les télécharger une par une.",
  "home-download-360-message": "Il s'agit d'un contenu interactif, mieux visible dans cet album. Vous pouvez tout de même télécharger le fichier brut pour le partager en ligne ou l'ouvrir plus tard dans des applications prenant en charge le format 360 sphérique.",
  "home-scanned-image-confirm-message": "Super photo ! Pour des raisons de sécurité, veuillez confirmer. Est-ce bien votre image ?",
  "home-media-share-title": "Média",
  "webapp-share-title": "Découvrez mon album Storibox !",
  "webapp-ogp-title": "Mon album Storibox",
  "webapp-ogp-description": "Consultez et partagez les photos et vidéos de mon album Storibox.",
  "home-share-files-unsupported-message": "Votre navigateur ne prend pas en charge le partage de fichiers. Veuillez utiliser un autre navigateur ou télécharger directement les fichiers.",
  "home-share-files-waiting-message": "Téléchargement des fichiers à partager.<br/>Veuillez patienter.",
  "title-select-a-combo": "Choisissez un pack",
  "title-select-a-la-carte": "À la carte",
  "title-shopping-cart": "Panier",
  "checkout-change-image-btn": "Changer l'image",
  "checkout-empty-cart-message": "Le panier est vide",
  "checkout-add-product-btn": "Ajouter un produit",
  "checkout-subtotal-label": "Sous-total :",
  "checkout-taxes-label": "Taxes (0 %)",
  "checkout-total-label": "Montant total :",
  "checkout-promo-code-placeholder": "code promo",
  "checkout-add-on-btn": "+ Ajouter un article",
  "checkout-invalid-promo-code-message": "Code promotionnel invalide ou non applicable !",
  "checkout-discount-label": "Remise : {{title}}",
  "checkout-delete-restriction-message": "Vous devez conserver au moins un pack dans votre panier si vous souhaitez acheter des articles supplémentaires. Si vous devez changer de pack, veuillez d'abord retirer tous les articles supplémentaires de votre panier.",
  "checkout-digital-package-upsell-message": "Souhaitez-vous ajouter<br>un pack numérique à votre<br>panier et obtenir l'accès à<br>tous vos fichiers numériques ?",
  "photo-plus-maybe-later-btn": "Peut-être plus tard",
  "photo-plus-upgrade-btn": "Oui, passer à Photo+",
  "checkout-digital-package-duplicate-message": "Vous avez déjà un pack d'accès numérique dans votre panier.<br>Un nouveau pack ne peut pas être ajouté tant que l'actuel n'est pas supprimé ou acheté.",
  "title-change-image": "Sélectionner une photo",
  "title-select-images": "Sélectionner des photos",
  "title-registered-selfies": "Visages enregistrés",
  "title-privacy": "Conditions générales",
  "title-faq": "FAQ",
  "title-shoot": "Prise de vue",
  "title-remote-shoot": "Prise de vue à distance",
  "title-thank-you": "Merci",
  "shoot-again-btn": "Reprendre",
  "select-image-done-btn-name_final": "Terminé",
  "select-image-done-btn-name_incomplete": "Suivant",
  "select-image-done-btn-counter_finite": "({{amount}}/{{total}})",
  "select-image-done-btn-counter_infinite": "({{amount}})",
  "remote-shoot-btn": "Prendre la photo",
  "remote-shoot-start-message": "Regardez l'appareil photo et cliquez sur \"Prendre la photo\" quand vous êtes prêt",
  "remote-shoot-countdown-message": "Regardez les lumières",
  "remote-shoot-rendering-message": "Votre contenu est en cours de création. Consultez votre album dans quelques secondes pour découvrir votre nouvelle vidéo !"
}
